import { useSkipToContentLink } from '@gov-nx/web';

export const SkipToContentLink = () => {
	const { skipToContentLinkHref, strings } = useSkipToContentLink();

	return (
		<nav
			className="header__skip-nav"
			aria-label={strings.ariaLabelNav}>
			<ul className="gov-list--plain">
				<li>
					<a
						href={skipToContentLinkHref}
						aria-label={strings.ariaLabelLink}
						className="header__skip-link">
						{strings.text}
					</a>
				</li>
			</ul>
		</nav>
	);
};
